import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { TextField } from "@mui/material";
import {
  ACHIEVEMENTS,
  DEFAULT_GAMIFICATION,
  readGamificationFromSettings,
} from "../utils/gamification";
import { AUTH_FIELD_SX } from "../pages/AuthLayout";

const fieldSx = { ...AUTH_FIELD_SX, maxWidth: "100%", width: "100%" };

export default function GamificationSettings({ value, onChange }) {
  const gamification = readGamificationFromSettings({ gamification: value });

  const patch = (next) => {
    onChange({
      ...gamification,
      ...next,
      monthlyChallenge: {
        ...gamification.monthlyChallenge,
        ...(next.monthlyChallenge ?? {}),
      },
    });
  };

  return (
    <section className="app-settings-card">
      <h3 className="app-settings-card__title">Геймификация</h3>
      <p className="app-settings-toggle__hint">
        XP, рейтинг, достижения и челленджи в боте для сотрудников.
      </p>

      <div className="app-settings-client-grid">
        <div className="app-settings-toggle">
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={gamification.enabled !== false}
                onChange={(event) => patch({ enabled: event.target.checked })}
              />
            }
            label="Включить геймификацию"
          />
        </div>

        <div className="app-settings-toggle">
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={gamification.showLeaderboard !== false}
                onChange={(event) =>
                  patch({ showLeaderboard: event.target.checked })
                }
              />
            }
            label="Показывать рейтинг"
          />
        </div>

        <div className="app-settings-toggle">
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={gamification.showAchievements !== false}
                onChange={(event) =>
                  patch({ showAchievements: event.target.checked })
                }
              />
            }
            label="Достижения"
          />
        </div>

        <div className="app-settings-toggle">
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={gamification.showStreaks !== false}
                onChange={(event) => patch({ showStreaks: event.target.checked })}
              />
            }
            label="Серии дней"
          />
        </div>

        <div className="app-settings-toggle">
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={gamification.certificateEnabled !== false}
                onChange={(event) =>
                  patch({ certificateEnabled: event.target.checked })
                }
              />
            }
            label="Сертификат при завершении"
          />
        </div>

        <div className="app-settings-field">
          <label className="app-settings-field__label">XP за правильный ответ</label>
          <TextField
            type="number"
            size="small"
            value={gamification.xpPerCorrect ?? DEFAULT_GAMIFICATION.xpPerCorrect}
            onChange={(event) =>
              patch({ xpPerCorrect: Number(event.target.value) || 0 })
            }
            sx={fieldSx}
          />
        </div>

        <div className="app-settings-field">
          <label className="app-settings-field__label">XP за завершение тренажёра</label>
          <TextField
            type="number"
            size="small"
            value={
              gamification.xpCompletionBonus ??
              DEFAULT_GAMIFICATION.xpCompletionBonus
            }
            onChange={(event) =>
              patch({ xpCompletionBonus: Number(event.target.value) || 0 })
            }
            sx={fieldSx}
          />
        </div>

        <div className="app-settings-field">
          <label className="app-settings-field__label">XP за завершение сценария</label>
          <TextField
            type="number"
            size="small"
            value={
              gamification.xpScenarioComplete ??
              DEFAULT_GAMIFICATION.xpScenarioComplete
            }
            onChange={(event) =>
              patch({ xpScenarioComplete: Number(event.target.value) || 0 })
            }
            sx={fieldSx}
          />
        </div>

        <div className="app-settings-field app-settings-field--wide">
          <label className="app-settings-field__label">Текст сертификата</label>
          <TextField
            multiline
            minRows={4}
            fullWidth
            value={gamification.certificateText ?? DEFAULT_GAMIFICATION.certificateText}
            onChange={(event) => patch({ certificateText: event.target.value })}
            helperText="Плейсхолдеры: {name}, {title}, {score}, {rank}, {total}, {level}, {xp}, {date}"
            sx={fieldSx}
          />
        </div>

        <div className="app-settings-toggle app-settings-field--wide">
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={gamification.monthlyChallenge?.enabled === true}
                onChange={(event) =>
                  patch({
                    monthlyChallenge: {
                      ...gamification.monthlyChallenge,
                      enabled: event.target.checked,
                    },
                  })
                }
              />
            }
            label="Челлендж месяца"
          />
        </div>

        {gamification.monthlyChallenge?.enabled ? (
          <>
            <div className="app-settings-field">
              <label className="app-settings-field__label">Цель (завершений в месяц)</label>
              <TextField
                type="number"
                size="small"
                value={
                  gamification.monthlyChallenge?.targetCompletions ??
                  DEFAULT_GAMIFICATION.monthlyChallenge.targetCompletions
                }
                onChange={(event) =>
                  patch({
                    monthlyChallenge: {
                      ...gamification.monthlyChallenge,
                      targetCompletions: Number(event.target.value) || 1,
                    },
                  })
                }
                sx={fieldSx}
              />
            </div>
            <div className="app-settings-field app-settings-field--wide">
              <label className="app-settings-field__label">Текст приза</label>
              <TextField
                fullWidth
                size="small"
                value={gamification.monthlyChallenge?.prizeText ?? ""}
                onChange={(event) =>
                  patch({
                    monthlyChallenge: {
                      ...gamification.monthlyChallenge,
                      prizeText: event.target.value,
                    },
                  })
                }
                placeholder="Например: сертификат или приз от HR"
                sx={fieldSx}
              />
            </div>
          </>
        ) : null}
      </div>

      <div className="app-settings-field app-settings-field--wide">
        <span className="app-settings-field__label">Достижения в проекте</span>
        <ul className="app-gamification-achievements">
          {ACHIEVEMENTS.map((item) => (
            <li key={item.id}>
              {item.icon} <strong>{item.title}</strong> — {item.description}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
